module.exports = __webpack_public_path__ + "img/album08_05.f9a3ab3f.jpg";